<template>
  <div
    v-if="show"
    class="floating-go-back-button"
    :class="{ 'floating-go-back-button--visible': show }"
  >
    <div class="floating-btn-container elevation-4 ga-4 pa-4 d-flex align-center">
      <div
        role="button"
        class="main-content d-flex align-center ga-2"
        @click="handleGoBack"
        data-testid="floating-go-back-button"
      >
        <v-icon size="16" icon="$return" class="mr-2" />
        <span class="back-text body1 text-white">{{ $t("securityGaps.backToSecurityGaps") }}</span>
      </div>
      <div
        class="dismiss-link body2"
        @click="handleDismiss"
        data-testid="floating-go-back-dismiss-button"
      >
        {{ $t("general.dismiss") }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["go-back", "dismiss"],
  setup(props, { emit }) {
    const handleGoBack = () => {
      emit("go-back");
    };

    const handleDismiss = () => {
      emit("dismiss");
    };

    return {
      handleGoBack,
      handleDismiss,
    };
  },
});
</script>

<style scoped lang="scss">
.floating-go-back-button {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  opacity: 0;
  transition:
    opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;

  &--visible {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }

  .floating-btn-container {
    background-color: rgb(var(--v-theme-primary));
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    min-height: auto;

    &:hover {
      .back-text,
      .icon-return {
        opacity: 0.9;
      }
    }

    .dismiss-link {
      color: rgb(var(--v-theme-blue-light));

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
